import React, { useMemo } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { toRichTextQuestionAnswer } from '../../stores/QuestionStore';
import { DisplayMode } from '../RenderForm';
import { AsyncEditRichTextParagraph } from './edit/edit-rich-text-paragraph';
import { ViewRichTextParagraph } from './view/ViewRichTextParagraph';
export var RichTextParagraph = observer(function (_ref) {
  var id = _ref.id,
    questionStore = _ref.questionStore,
    displayMode = _ref.displayMode;
  var richTextValue = toJS(toRichTextQuestionAnswer(questionStore.currentAnswer));
  var showEditComponent = displayMode === DisplayMode.Edit;

  //We pass a cloned 'richTextValue' to avoid the mutation by AsyncEditRichTextParagraph component
  var richTextValueCloned = useMemo(function () {
    return cloneDeep(richTextValue);
  }, [richTextValue]);
  if (showEditComponent) {
    return /*#__PURE__*/React.createElement(AsyncEditRichTextParagraph, {
      id: id,
      value: richTextValueCloned,
      isInvalid: !!questionStore.validationErrors,
      onChange: function onChange(answer) {
        if (!isEqual(richTextValue, answer)) {
          questionStore.setAnswer(answer);
        }
      }
    });
  }
  return /*#__PURE__*/React.createElement(ViewRichTextParagraph, {
    id: id,
    value: richTextValue,
    displayMode: displayMode
  });
});